import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                icon: 'pi pi-home',
                items: [
                    {
                        label: $localize`Pacientes`,
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/patient']
                    },
                    {
                        label: $localize`Sesiones`,
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/session']
                    }
                ]
            }
        ];
    }
}
